import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { useTransferMoneyContext } from '../hooks/useTransferMoneyContext';

export enum DistributionReasonValueDTO {
  Normal,
  Disability,
  ExcessContributionRemovalBeforeTaxDeadline,
  ExcessContributionRemovalAfterTaxDeadline,
  RolloverToQualifiedPlan,
  RolloverToIra,
  Transfer,
  RecharacterizationPriorYear,
  RecharacterizationCurrentYear,
  Conversion,
  ManagementFee,
  PrematureSimpleIraLessThan2Years,
  NormalRothIraGreaterThan5Years,
  Premature,
  Death,
}

export enum DistributionWithholdingTypeDTO {
  Voluntary,
  MandatoryOptOut,
  Mandatory,
  VoluntaryRelativeToFederal,
  MandatoryRelativeToFederal,
}

export enum DistributionWithholdingUnitDTO {
  Any,
  Percentage,
  Dollar,
}

export interface DistributionReasonDTO {
  value: DistributionReasonValueDTO;
  hasStateTaxWithholding: boolean;
  hasFederalTaxWithholding: boolean;
}

export interface StateWitholdingDetailsDTO {
  option: DistributionWithholdingTypeDTO;
  amountType: DistributionWithholdingUnitDTO;
  minimumAmount: number;
  optOutForm: string | null;
  percentageRelativeToFederalTax: number;
}

export type WithdrawalOptionsDTO = { stateWitholdingDetails: StateWitholdingDetailsDTO | null } & (
  | {
      isIraAccount: true;
      distributionReasons: DistributionReasonDTO[];
    }
  | {
      isIraAccount: false;
      distributionReasons: null;
    }
);

const fetchWithdrawalOptions = async (
  clientId: string,
  managedAccountId: string,
): Promise<WithdrawalOptionsDTO> => {
  return authFetch(
    urlWithParams('/Consumer/AchTransfers/WithdrawalOptions', {
      clientId,
      managedAccountId,
    }),
  );
};

export const useWithdrawalOptionsQuery = () => {
  const { clientId, managedAccountId } = useTransferMoneyContext();

  return useQuery(
    queryKeys.withdrawalOptions(clientId, managedAccountId),

    () => fetchWithdrawalOptions(clientId, managedAccountId),
  );
};
